import { BRDGE_PROJECT_ID } from "~/lib/config";

export const useOnboardingStore = defineStore(
    `onboarding_${BRDGE_PROJECT_ID}`,
    {
        state: () => ({
            completed: false,
            initialTime: null as number | null,
            snoozeUntil: null as number | null,
            rated: false,
        }),
        actions: {
            setCompleted() {
                this.completed = true;
            },
            setInitialTime() {
                this.initialTime = Date.now();
            },
            snooze(minutes: number) {
                this.snoozeUntil = Date.now() + minutes * 60 * 1000;
            },
            setRated() {
                this.rated = true;
            },
        },
        persist: {
            storage: persistedState.cookiesWithOptions({
                maxAge: 31536000, // 365 days
            }),
        },
    }
);
